
import {
  ref,
  computed,
  PropType,
  defineComponent,
  watch,
  reactive,
  nextTick
} from 'vue'

import { Entry, UUID } from '@Protium/vue-ozone-utils'
import ListHeader from '@/components/ListHeader.vue'

import { PAGE_SIZE } from '@/pages/Import/constants'

export default defineComponent({
  name: 'TableListView',
  components: { ListHeader },
  props: {
    items: {
      type: Array as PropType<Array<Entry>>,
      required: true
    },
  },
  emits: ['active','resolved', 'type', 'expand', 'update:modelValue'],
  setup (props, { emit }) {
    const visibleColumns = ['reference']
    const state = reactive({
      loading: false,
      items: props.items,
      nextPage: 2,
      lastPage: computed(() => Math.ceil((state.items || []).length / PAGE_SIZE)),
      rows: computed(() => state.items.slice(0, PAGE_SIZE * (state.nextPage - 1))),
      pagination: {
        rowsPerPage: 0
      },
      datamaps: []
    })

    function onTableScroll ({ to, ref }) {
      const lastIndex = (state.rows || []).length - 1

      if (state.loading !== true && state.nextPage < state.lastPage && to === lastIndex) {
        state.loading = true

        setTimeout(() => {
          state.nextPage++

          void nextTick(() => {
            ref.refresh()
            state.loading = false
          })
        }, 500)
      }
    }

    // const address = ref(null)
    // const fulfillmentData = ref({ items: null, labels: null })
    // const operationalNotes = ref(null)
    // const meta = ref(null || {})
    // const statusInfo = ref(null)

    // const operationalData = computed({
    //   get: () => {
    //     return {fulfillments: fulfillmentData.value, notes: operationalNotes.value, address: address.value, statusInfo: statusInfo.value, meta: meta.value}
    //   },
    //   set: (value) => {
    //     if(!value) return
    //     if(value.fulfillments) fulfillmentData.value = value.fulfillments
    //     if(value.notes) operationalNotes.value = value.notes
    //     if(value.address) address.value = value.address
    //     if(value.statusInfo) statusInfo.value = value.statusInfo
    //     if(value.meta) meta.value = value.meta
    //   }
    // })

    function emitUpdate (e) {
      emit('update:modelValue', e)
    }

  return {
    emitUpdate,
    visibleColumns,
    onTableScroll
  }
}
})

